import React, { useState } from "react";
import styled from "styled-components";
import { ChevronRightArrow, CloseIcon } from "../svgs";
import { StyledText } from "../common/basic";
import { useHistory } from "react-router-dom";

import backgroundImage from "../images/referral_ad.jpg";
import EnterReferralCodeModal from "../../screens/subscriber/referral/components/enterReferralCodeModal";

const ReferAndEarnView = () => {
  const [openReferralModal, setOpenReferralModal] = useState(false);

  const history = useHistory();
  return (
    <>
      <div style={{ marginLeft: 20, marginRight: 20, marginTop: 20 }}>
        <p style={{ fontSize: 20, fontWeight: "bold" }}>Refer & Earn</p>
        <Wrapper
          onClick={() => history.push(`/referral`)}
        // onClick={() => setOpenReferralModal(true)}
        >
          <Image src={backgroundImage} />
          <CardDetails>
            <Body>
              <StyledText size={26} color={"white"}>
                Refer Pals
              </StyledText>
              <StyledText
                size={14}
                color={"white"}
                style={{
                  marginTop: -20,
                  textAlign: "center",
                  fontFamily: "MTNRegular",
                }}
              >
                Get data & gift vouchers
              </StyledText>
            </Body>

            <Arrow color="#fff">
              <ChevronRightArrow fill="#fff" width="10" />
            </Arrow>
          </CardDetails>
        </Wrapper>
      </div>
      {openReferralModal && <EnterReferralCodeModal onBackDropClick={() => setOpenReferralModal(false)} />}
    </>
  );
};

const Wrapper = styled.div`
  width: 100%;
  height: 350px;
  border-radius: 20px;
`;

const Image = styled.img`
  width: 100%;
  border-radius: 20px;
`;

const Body = styled.div`
  max-width: 310px;
  padding: 20px;
`;

const Arrow = styled.div`
  width: 36px;
  height: 36px;
  border-radius: 30px;
  border-width: thin;
  border-color: white;
  border-style: solid;
  justify-content: center;
  align-items: center;
  display: flex;
  margin-right: 20px;
  margin-top: 20px;
`;

const CardDetails = styled.div`
  width: 100%;
  // display: flex;
  display: none;
  align-items: center;
  justify-content: space-between;
  margin-top: -20px;
`;

const CloseIconContainer = styled.div`
  position: absolute;
  top: 10px;
  right: 20px;
`;

const ModalImage = styled.img`
  width: 400px;
  border-radius: 20px;
  object-fit: cover;
  margin-top: -20px;
`;

const ModalBody = styled.div`
  max-width: 310px;
`;

export default ReferAndEarnView;
